module.exports = __webpack_public_path__ + "img/67.ea3a7784.jpg";